export const hasFilterValue = (value) => {
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'number') return !isNaN(value);
  if (typeof value === 'string') return value.trim().length > 0;

  return value !== undefined && value !== null && value !== false;
};

export const countValues = (...values) => values.filter(hasFilterValue).length;
